import gql from "graphql-tag";

export default {
  createCreatedForm: gql`
    mutation(
      $form: ID!
      $fileUrl: String
      $createdFormFields: String
      $code: String
      $title: String!
      $description: String
    ) {
      createCreatedForm(
        data: {
          formId: $form
          fileUrl: $fileUrl
          createdFormFields: $createdFormFields
          code: $code
          title: $title
          description: $description
        }
      ) {
        id
        title
        code
        description
        approvalStatus
        approvalCurrentStep
        approvalTotalStep
        createdFormFields {
          id
          name
          code
          description
          type
          value
          createdAt
          updatedAt
        }
        approvalSteps {
          id
          approvalCurrentStep
          approvalStatus
          approvalNote
          createdAt
          author {
            username
            fullname
            department {
              name
            }
            position {
              name
            }
          }
        }
        currentApprovalStep {
          stepOrder
          stepName
          user
          department
          position
        }
        author {
          id
          username
        }
        createdAt
        updatedAt
      }
    }
  `
};
